import { render, staticRenderFns } from "./VehiculoEstado.vue?vue&type=template&id=80a262e2"
import script from "./VehiculoEstado.vue?vue&type=script&lang=js"
export * from "./VehiculoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports